import { StateTree } from '@makemydeal/dr-dash-types';
import { BaseTabs } from '../actionTypes/baseDealTypes';

export const getActiveTab = (state: StateTree) => {
    return state.baseDeal.activeTab || BaseTabs.SUMMARY;
};
